import { Button } from '@mui/material'

export default function BackButton({ back }) {
  return <Button
    onClick={back}
    style={{ marginTop: 16, width: 'fit-content' }}
    variant="contained"
    disableElevation
  >retour</Button>
}